import React, { useMemo, useState } from 'react'
import { removeBatch } from '../../../../pages/ReceivementFresh/ReceivementApi'
import { Batch } from '../../FractionTypes'
import ModalDeleteBatchFractionable from './index'

const useDeleteBatch = ({ onRemove }) => {
  const [deleteBatchFractionable, setDeleteBatchFractionable] = useState<Batch>()

  const handleClickBatchFractionable = useMemo(() => (batch) => setDeleteBatchFractionable(batch), [])

  const handleBatchFractionableRemove = async (userBadge) => {
    if (!userBadge) throw new Error('Crachá do usuário inválido')

    await removeBatch(deleteBatchFractionable?.id_lote, userBadge)
    await onRemove()
  }

  const RemoveBatchFractionableModalComponent = () => (
    <ModalDeleteBatchFractionable
      deleteObject={deleteBatchFractionable}
      cancelAction={() => setDeleteBatchFractionable(undefined)}
      deleteAction={handleBatchFractionableRemove}
    />
  )

  return [handleClickBatchFractionable, RemoveBatchFractionableModalComponent]
}

export default useDeleteBatch
